module.exports = {
  insuranceNewCar: { human: 'Neuzulassung (eVB)', api: 'insuranceNewCar' },
  insuranceExistingCar: { human: 'Versichererwechsel (VBÜ)', api: 'insuranceExistingCar' }
}
